import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Button, DialogContentText } from '@mui/material';

import OperationForm from './OperationForm';

const PSM_STATE_PUSH = 2;

function toPayload(v) {
  return {
    catm: {
      state: Number(v.catmState),
      tauMinutes: Number(v.catmTau),
      ratSeconds: Number(v.catmRat),
    },
    nbiot: {
      state: Number(v.nbiotState),
      tauMinutes: Number(v.nbiotTau),
      ratSeconds: Number(v.nbiotRat),
    },
  };
}

export default function ConfSetPSM(props, context) {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(null);

  const handleFormSubmit = (data) => {
    setValues(data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setValues(null);
  };

  const handleConfirm = () => {
    if (values) {
      props.updateConfig(toPayload(values));
    }
    handleClose();
  };

  const showNbiotPushWarning =
    values != null && Number(values.nbiotState) === PSM_STATE_PUSH;

  return (
    <>
      <OperationForm
        stacked
        enable={props.enable}
        fields={props.fields}
        onSubmit={handleFormSubmit}
      />

      <Dialog open={open} onClose={handleClose} maxWidth="sm">
        <DialogContent>
          <DialogContentText
            style={{ fontSize: 'large', color: 'black', textAlign: 'center' }}
          >
            {context.t(
              'you_are_about_to_take_a_significant_action_on_num_devices',
              { num: props.countSelected }
            )}
            <br />
            <span
              style={{ fontSize: 'medium', color: '#606060', display: 'block' }}
            >
              {context.t('confirm_updating_psm_config')}
            </span>
            {showNbiotPushWarning && (
              <span
                style={{
                  fontSize: 'medium',
                  color: '#c0392b',
                  display: 'block',
                  marginTop: '6px',
                }}
              >
                {context.t('psm_nbiot_push_warning')}
              </span>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {context.t('cancel')}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {context.t('continue')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ConfSetPSM.propTypes = {
  enable: PropTypes.bool,
  countSelected: PropTypes.number,
  fields: PropTypes.array,
  updateConfig: PropTypes.func.isRequired,
};

ConfSetPSM.defaultProps = {
  enable: false,
  countSelected: 0,
  fields: [],
};

ConfSetPSM.contextTypes = {
  t: PropTypes.func.isRequired,
};
